import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useTranslation } from 'react-i18next';
import api from '../../api/api';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../../hooks/useNotification';

export default function GoogleAuthButton() {
  const { t } = useTranslation('auth');
  const { login } = useAuth();
  const navigate = useNavigate();
  const { show } = useNotification();

  const handleSuccess = async (credentialResponse) => {
    try {
      const res = await api.post('/auth/google', { idToken: credentialResponse.credential });
      if (res.data.success) {
        const { token, user } = res.data;
        login(token, user);
        const profileIncomplete = !user?.storeName || !user?.phoneNumber;
        navigate(profileIncomplete ? '/products/order-tracking/profile' : '/products/order-tracking/dashboard');
      } else {
        show(res.data.message || t('google.signInFailed'), 'error');
      }
    } catch (err) {
      show(err.response?.data?.message || t('google.signInFailed'), 'error');
    }
  };

  return (
    <div className="google-auth-container">
      <div className="google-auth-divider">
        <span>{t('google.or')}</span>
      </div>
      <div className="google-auth-btn">
        <GoogleLogin
          onSuccess={handleSuccess}
          onError={() => show(t('google.signInCancelled'), 'error')}
          shape="rectangular"
          theme="outline"
          size="large"
          width="360"
        />
      </div>
    </div>
  );
}
